import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { SupplierService } from '@vdms-hq/api-contract';
import { startWith, switchMap, tap } from 'rxjs/operators';

@Injectable()
export class SuppliersFetcher {
  private readonly suppliersService = inject(SupplierService);

  refresh$ = new Subject<void>();
  loading$ = new BehaviorSubject<boolean>(false);

  suppliers$ = this.refresh$.pipe(
    startWith(null),
    tap(() => this.loading$.next(true)),
    switchMap(() => this.suppliersService.getSuppliers()),
    tap(() => this.loading$.next(false)),
  );
}
